import styled from "@emotion/styled";
import { Card } from "@mui/material";

export const TruckStopOrdersCardWrapper = styled(Card)(({ theme }) => ({
	padding: 16,
	display: "flex",
	flexDirection: "column",
	gap: 16,
	width: "100%",
	boxSizing: "border-box"
}));

export const TruckStopOrdersCardHeader = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "flex-start",
	justifyContent: "space-between",
	gap: "24px",
	span: {
		...theme.project.typography.subtitle.subtitle2,
		color: theme.project.colors.fontColors.secondary
	},
	"> div:first-of-type": {
		display: "flex",
		flexDirection: "column",
		"span:first-of-type": {
			height: 36,
			display: "flex",
			alignItems: "center"
		},
		"span:last-of-type": {
			...theme.project.typography.body.body2,
			color: theme.project.colors.fontColors.main
		}
	},
	"> div:last-of-type": {
		display: "flex",
		gap: 16,
		[theme.breakpoints.up("md")]: {
			width: "100%",
			maxWidth: "max-content",
			justifyContent: "end",
			alignItems: "center"
		}
	},
	"> span": {
		...theme.project.typography.overline
	},
	svg: {
		color: theme.project.colors.primaryColors.main
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		gap: 16,
		div: {
			flexDirection: "column",
			width: "100%"
		}
	}
}));

export const TruckStopOrdersCardSubheader = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	"> div": {
		display: "flex",
		gap: 24
	},
	"> span": {
		...theme.project.typography.overline,
		color: theme.project.colors.fontColors.main
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		alignItems: "flex-start",
		gap: 16,
		"> div": {
			flexDirection: "column",
			gap: 16,
			width: "100%"
		}
	}
}));

export const TruckStopOrdersNoOrders = styled.div(({ theme }) => ({
	height: 139,
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	gap: "8px",
	h6: {
		margin: 0
	},
	span: {
		...theme.project.typography.body.body1
	}
}));

export const TruckStopOrdersSkeleton = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: 24,
	div: {
		display: "flex",
		flexDirection: "column",
		gap: 16
	},
	"> div": {
		gap: 48,
		justifyContent: "space-between",
		"> div": {
			flex: 1,
			"> div > div": {
				flex: 1,
				gap: 8
			}
		}
	},
	[theme.breakpoints.up("md")]: {
		"> div, > div > div > div": {
			flexDirection: "row"
		}
	}
}));
